module.exports = __webpack_public_path__ + "assets/img/5-1.b6d1b1dc.png";